import { render, staticRenderFns } from "./ModalContractEndsComponent.vue?vue&type=template&id=315bff48"
import script from "./ModalContractEndsComponent.vue?vue&type=script&lang=js"
export * from "./ModalContractEndsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports